// extracted by mini-css-extract-plugin
module.exports =  {"note":"pwSNIK","button":"gc6fSV","body":"iKsFsS","icon":"L9QG3X"};